import { Chat3LineIcon, Empty } from 'ui';

const CommentsEmpty = () => (
  <Empty
    description={{
      subtitle: 'Be first to add a comment and start a discussion',
      title: 'The conversation is about to begin',
    }}
    image={<Chat3LineIcon />}
  />
);

export default CommentsEmpty;
